import React from "react";
import backgroundimg from "./../image/banner.png";
import { Helmet } from "react-helmet";

const Cookie = () => {
  return (
    <div className="w-full mx-w-[1400px] h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title>Cookie Policy - Nexify InfoSystems</title>
        <meta
          name="description"
          content="Learn about the cookies used by Nexify InfoSystems to enhance your website experience and how you can manage them."
        />
        <meta
          name="keywords"
          content="Nexify, cookies, cookie policy, website cookies, tracking technologies, user preferences, website analytics"
        />
      </Helmet>
      {/* Header Section */}
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
              Cookie Policy
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Understanding how Nexify InfoSystems uses cookies
            </h2>
          </div>
        </div>
      </div>

      {/* Cookie Policy Content Section */}
      <div className="bg-white flex flex-col items-left text-left p-6 w-full max-w-[1200px] mt-5 gap-6 mb-20">
        <h2 className="lg:text-[40px] text-2xl font-semibold text-[#005eb8]">
          Nexify InfoSystems Cookie Policy
        </h2>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">What Are Cookies?</h3>
          <p className="text-gray-700 mb-4">
            Cookies are small text files placed on your device when you visit a website. These cookies allow us to collect certain information about your device and your activities on our website.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">How We Use Cookies</h3>
          <p className="text-gray-700 mb-2">We use cookies to:</p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li>Enhance your user experience.</li>
            <li>Remember your preferences and settings.</li>
            <li>Analyze website traffic and user behavior.</li>
            <li>Provide targeted advertisements.</li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Types of Cookies We Use</h3>
          <p className="text-gray-700 mb-2">We use the following types of cookies:</p>
          <ul className="list-disc list-inside text-gray-700 mb-4">
            <li><span className="font-semibold">Essential Cookies:</span> These cookies are necessary for the website to function properly.</li>
            <li><span className="font-semibold">Performance Cookies:</span> These cookies help us analyze how visitors use the site.</li>
            <li><span className="font-semibold">Functional Cookies:</span> These cookies allow the website to remember choices you make (e.g., language preference).</li>
            <li><span className="font-semibold">Targeting Cookies:</span> These cookies track your browsing activity to deliver personalized content and ads.</li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Managing Cookies</h3>
          <p className="text-gray-700 mb-4">
            You can control cookie settings through your browser. Most browsers allow you to block cookies or delete them. Please note that disabling cookies may affect the functionality of the website.
          </p>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Changes to This Cookie Policy</h3>
          <p className="text-gray-700">
            We may update this Cookie Policy from time to time. Any changes will be posted on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cookie;